export const records = [
  {
    id: 1,
    name: "Jon Snow",
    email: "jonsnow@gmail.com",
    age: 35,
    phone: "(665)121-5454",
    edited: false,
    edits: 0,
  },
  {
    id: 2,
    name: "Cersei Lannister",
    email: "cerseilannister@gmail.com",
    age: 42,
    phone: "(421)314-2288",
    edited: false,
    edits: 0,
  },
  {
    id: 3,
    name: "Jaime Lannister",
    email: "jaimelannister@gmail.com",
    age: 45,
    phone: "(422)982-6739",
    edited: true,
    edits: 3,
  },
  {
    id: 4,
    name: "Anya Stark",
    email: "anyastark@gmail.com",
    age: 16,
    phone: "(921)425-6742",
    edited: false,
    edits: 0,
  },
  {
    id: 5,
    name: "Daenerys Targaryen",
    email: "daenerystargaryen@gmail.com",
    age: 31,
    phone: "(421)445-1189",
    edited: true,
    edits: 2,
  },
  {
    id: 6,
    name: "Ever Melisandre",
    email: "evermelisandre@gmail.com",
    age: 150,
    phone: "(232)545-6483",
    edited: true,
    edits: 29,
  },
  {
    id: 7,
    name: "Ferrara Clifford",
    email: "ferraraclifford@gmail.com",
    age: 44,
    phone: "(543)124-0123",
    edited: false,
    edits: 0,
  },
  {
    id: 8,
    name: "Rossini Frances",
    email: "rossinifrances@gmail.com",
    age: 36,
    phone: "(222)444-5555",
    edited: false,
    edits: 0,
  },
  {
    id: 9,
    name: "Harvey Roxie",
    email: "harveyroxie@gmail.com",
    age: 65,
    phone: "(444)555-6239",
    edited: false,
    edits: 0,
  },
  {
    id: 10,
    age: "",
    name: "Kiana Holcomb",
    email: "kiana@gmail.com",
    phone: "(421)314-2288",
    edited: true,
    edits: 14,
  },
  {
    id: 11,
    age: "",
    name: "Grayce Muthui",
    email: "graycemuthui20@gmail.com",
    phone: "(901)314-2288",
    edited: true,
    edits: 24,
  },
  {
    id: 12,
    age: "",
    name: "Kamau Moii",
    email: "kamau@gmail.com",
    phone: "(421)316-2789",
    edited: true,
    edits: 4,
  },
  {
    id: 13,
    age: "",
    name: "Mike Jos",
    email: "mike@gmail.com",
    phone: "(221)309-2678",
    edited: false,
    edits: 0,
  },
  {
    id: 14,
    name: "Bright Kweku",
    email: "bright@gmail.com",
    age: 30,
    phone: "(421)445-2234",
    edited: true,
    edits: 34,
  },
  {
    id: 15,
    name: "Kwame Kofi",
    email: "kwame@gmail.com",
    age: 35,
    phone: "(421)445-1189",
    edited: false,
    edits: 0,
  },
  {
    id: 16,
    name: "Kofi Bright",
    email: "kofi@gmail.com",
    age: 40,
    phone: "(421)445-1459",
    edited: true,
    edits: 4,
  },
  {
    id: 17,
    age: "",
    name: "Shaq Deff",
    email: "shaq@gmail.com",
    phone: "(445)445-1249",
    edited: true,
    edits: 24,
  },
  {
    id: 18,
    age: "",
    name: "Sandy Mutinda",
    email: "sandy@gmail.com",
    phone: "(341)235-1163",
    edited: false,
    edits: 0,
  },
];

export default function checkPercentage(records) {
  let missingAge = 0;
  let totalRecords = records.length;
  for (let i = 0; i < records.length; i++) {
    if (records[i].age === "") {
      missingAge++;
    }
  }
  let percentage = (missingAge / totalRecords) * 100;
  return percentage;
}
